import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { apiClientV5 } from './apiClientV5';

const customV5Instance = <T>(config: AxiosRequestConfig): Promise<T> => {
  const controller = new AbortController();
  const promise = apiClientV5({
    ...config,
    signal: controller.signal,
  }).then(({ data }: AxiosResponse) => data);

  // @ts-ignore
  promise.cancel = () => {
    controller.abort();
  };

  return promise;
};

// In some case with react-query and swr you want to be able to override the return error type so you can also do it here like this
export type ErrorType<Error> = AxiosError<Error>;
export default customV5Instance;
